import type { UserManagerSettings } from "oidc-client-ts";
import { getConfig } from "../config";

export function getOidcSettings(): UserManagerSettings {
  const config = getConfig();
  return {
    authority: config.IDENTITY_URL,
    client_id: "employer-intake-spa",
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/logged-out`,
    response_type: "code",
    scope: "openid profile email offline_access optimyl:claims",
    automaticSilentRenew: true,
  };
}
